{
  "entities": {
    "warehouses": "Warehouse | Warehouses",
    "loadtypes": "Load Type | Load Types",
    "organizations": "Organization | Organizations",
    "orgs": "Org | Orgs"
  }
}
